// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popover{max-width:500px}.chatbot-popover{width:300px}.chatbot-popover-button{background-color:#491c96 !important;float:right;color:#fff !important;margin-bottom:10px}.chatbot-popover-content-section{display:flex;align-items:center;align-items:flex-start}.chatbot-popover-content-section-image{margin-right:10px}.pathfinder-chatbot{display:none !important}", ""]);
// Exports
module.exports = exports;
